import React from 'react';
import { Image, ActivityIndicator } from "react-native"
import type { AthleteProps, BracketProps, EventProps, PlayerBracketPickProps, RoundEventProps, TeamProps } from "../../../types"
import { BracketCompetitionHelpers } from '../../api';
import { useColors } from '../../../constants/useColors';
import { Button, Text, View } from '../../../Components/Themed';
import { Icons } from '../../../Components';


type RoundEventCardProps = {
    round_event:RoundEventProps,
    round_events:RoundEventProps[],
    event?:EventProps,
    player_bracket_pick?:PlayerBracketPickProps,
    away_team?:TeamProps,
    home_team?:TeamProps,
    away_placeholder_team?:TeamProps,
    home_placeholder_team?:TeamProps,
    away_athlete?:AthleteProps,
    bracket?:BracketProps,
    home_athlete?:AthleteProps,
    compact?:boolean,
    orientation?:'left'|'right',
    loading?:boolean,
    width:number,
    no_pick?:boolean,
    away_placeholder_pick?:PlayerBracketPickProps,
    home_placeholder_pick?:PlayerBracketPickProps,
    onPick:(player_bracket_pick:PlayerBracketPickProps) => void,
    onSelectContest?:(round_event:RoundEventProps, player_bracket_pick?:PlayerBracketPickProps, away_placeholder_pick?:PlayerBracketPickProps, home_placeholder_pick?:PlayerBracketPickProps) => void
}

const RoundEventCard = ({ event, loading, orientation, compact, bracket, away_team, away_placeholder_team, home_placeholder_team, home_team, width, no_pick, round_event, player_bracket_pick, away_placeholder_pick, home_placeholder_pick, onPick, onSelectContest }:RoundEventCardProps) => {
    //AWAY PLACEHOLDER
    const round_width = width//width > 600 ? undefined : width / 2
    const no_name = width < 195 ? true : false
    const Colors = useColors();
    const handleSelectAway = () => {
        if(loading){ return } 
        //Okay! Lets get the side_id
        let side:'away' = 'away'
        let side_id:string|undefined = undefined
        let side_type:string = 'team'
        let pick_seed:number|undefined = 0
        if(away_placeholder_pick){
            side_id = away_placeholder_pick.pick_side_id
            side_type = 'team'
            pick_seed = away_placeholder_pick.pick_seed
        } else if(round_event.away_side_id){
            side_id = round_event.away_side_id
            side_type = 'team'
            pick_seed = round_event.away_seed
        }

        if(!side_id || !pick_seed){ return alert('Unable to process') }
        let new_pick = BracketCompetitionHelpers.createPlayerBracketPick(round_event.bracket_id, round_event, side, side_id, pick_seed)
        onPick({ ...new_pick, player_bracket_pick_id: player_bracket_pick?.player_bracket_pick_id??'', pick_side_type: side_type })
    }

    const handleSelectHome = () => {
        //Okay! Lets get the side_id
        if(loading){ return console.log('HEY WAS LOGIN!!!') }
        let side:'home' = 'home'
        let side_id:string|undefined = undefined
        let side_type:string = 'team'
        let pick_seed:number|undefined = 0
        if(home_placeholder_pick){
            side_id = home_placeholder_pick.pick_side_id
            side_type = 'team'
            pick_seed = home_placeholder_pick.pick_seed
        } else if(round_event.home_side_id){
            side_id = round_event.home_side_id
            side_type = 'team'
            pick_seed = round_event.home_seed
        }

        if(!side_id || !pick_seed){ return alert('Unable to process') }
        let new_pick = BracketCompetitionHelpers.createPlayerBracketPick(round_event.bracket_id, round_event, side, side_id, pick_seed)
        onPick({ ...new_pick, player_bracket_pick_id: player_bracket_pick?.player_bracket_pick_id??'', pick_side_type: side_type })
    }

    const getPickColor = (side:'away'|'home', pbb?:PlayerBracketPickProps) => {
        if(!pbb){ return Colors.text.h1 }
        if(pbb.pick_side && pbb.pick_side != side){ return Colors.text.h1 }
        switch(pbb.result_ind){
            case 'win': return Colors.text.success
            case 'lose': return Colors.text.error
            default: return Colors.text.action 
        }
    }

    /*
    const getSideColor = (side:'away'|'home') => {
        if(!player_bracket_pick){ return Colors.brand.midnight }
        if(!player_bracket_pick.result_ind){ return Colors.brand.midnight }
        if(player_bracket_pick.result_ind == 'lose'){ return Colors.utility.error }
        if(player_bracket_pick.result_ind == 'win'){ return Colors.utility.success }
    }

    const isPicked = (side:'away'|'home') => {
        if(!player_bracket_pick){ return false }
        if(player_bracket_pick.pick_side == side){ return true } else { return false }
    }
    */

    const renderButton = (side:'away'|'home') => {
        if(no_pick){
            return (
                <View style={{ height:15, width:15, borderRadius:100 }} />
            )
        }
        if(!player_bracket_pick || player_bracket_pick.pick_side != side){
            return (
                <View style={{ height:15, width:15, borderRadius:100, borderWidth:1, borderColor:Colors.text.action }} />
            )
        }
        switch(player_bracket_pick.result_ind){
            case 'win':
                return (
                    <View style={{ height:15, width:15, borderRadius:100, borderWidth:1, borderColor:Colors.text.action, backgroundColor:Colors.text.success }} />
                )
            case 'lose':
                return (
                    <View style={{ height:15, width:15, borderRadius:100, borderWidth:1, borderColor:Colors.text.action, backgroundColor:Colors.text.error }} />
                )
            default: 
                return (
                    <View style={{ height:15, width:15, borderRadius:100, borderWidth:1, borderColor:Colors.text.action, backgroundColor:Colors.text.action }} />
                )
        }
    }


    const getScore = (side_id?:string) => {
        if(!event?.home || !event?.away){ return 0 }
        let side = event.home.team_id == side_id ? 'home' : 'away'
        if(side == 'away'){ return event.away_team_score }
        else { return event.home_team_score }
    }

    const renderLeftSide = (side:'away'|'home') => {
        switch(side){
            case 'away':
                return (
                    <View transparent>
                        {round_event?.away_side_id && away_placeholder_pick && away_placeholder_team ?
                        <View transparent style={{ padding:7, borderTopRightRadius:8, borderTopLeftRadius:8, borderBottomWidth:1, borderBottomColor:Colors.borders.light }}>
                            <Text size={10} theme='h2' color={away_placeholder_pick.result_ind=='win'?Colors.text.success:Colors.text.error}>{away_placeholder_team.market_name} {!no_name?away_placeholder_team.name:''}</Text>
                        </View>
                        :<></>}
                        <View style={{ flexDirection:'row', alignItems:'center', padding:12, borderTopRightRadius:!round_event?.away_side_id || !round_event.away_placeholder?8:0, borderTopLeftRadius:!round_event?.away_side_id || !round_event.away_placeholder?8:0 }}>
                            <View transparent style={{ flexDirection:'row', alignItems:'center', borderRightWidth:1, borderRightColor:Colors.borders.light }}>
                                <View transparent style={{ marginLeft:5 }}>
                                    {renderButton('away')}
                                </View>
                                {round_event.event_id && !no_name ?
                                    <Text style={{ margin:5}} size={10} theme='h2'>{getScore(away_team?.team_id)}</Text>
                                :<></>}
                            </View>
                            <View transparent style={{ flex:1, marginLeft:5, marginRight:0 }}>
                                {round_event.away_side_id && away_team ?
                                <View style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                    <Image
                                        source={{ uri: away_team.image?.url }}
                                        style={{ height:20, width:20, marginLeft:2 }}
                                        resizeMode="cover"
                                    />
                                    <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='description'>{!bracket?.hide_seeds?round_event.away_seed:''}</Text>
                                    {compact ?
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('away', player_bracket_pick)} theme='h2'>{away_team.abbr}</Text>                                
                                    :
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('away', player_bracket_pick)} theme='h2'>{away_team.market_name} {!no_name?away_team.name:''}</Text>   
                                    }                             
                                </View>
                                :
                                <View transparent>
                                    {away_placeholder_pick && away_placeholder_team ?
                                    <View transparent style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                        <Image
                                            source={{ uri: away_placeholder_team.image?.url }}
                                            style={{ height:20, width:20, marginLeft:2 }}
                                            resizeMode="cover"
                                        />
                                        <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='description'>{!bracket?.hide_seeds?away_placeholder_pick.pick_seed:''}</Text>
                                        {compact ?
                                        <Text style={{ flex:1 }} size={10} theme='h1'>{away_placeholder_team.abbr}</Text>
                                        :
                                        <Text style={{ flex:1 }} size={10} theme='h1'>{away_placeholder_team.market_name} {!no_name?away_placeholder_team.name:''}</Text>
                                        }
                                    </View>
                                    :
                                    <Text color='transparent'>select</Text>
                                    }
                                </View>
                                }
                            </View>
                            
                        </View>
                    </View>
                )
            case 'home':
                return (
                    <View transparent>
                        <View style={{ flexDirection:'row', alignItems:'center', padding:12, borderBottomRightRadius:!round_event?.home_side_id || !round_event.home_placeholder?8:0, borderBottomLeftRadius:!round_event?.home_side_id || !round_event.home_placeholder?8:0  }}>
                        <View transparent style={{ flexDirection:'row', alignItems:'center', borderRightWidth:1, borderRightColor:Colors.borders.light }}>
                            <View transparent style={{ marginLeft:5 }}>
                                    {renderButton('home')}
                                </View>
                                {round_event.event_id && !no_name ?
                                    <Text style={{ margin:5}} size={10} theme='h2'>{getScore(home_team?.team_id)}</Text>
                                :<></>} 
                            </View>
                            <View transparent style={{ flex:1, marginLeft:5 }}>
                                {round_event.home_side_id && home_team ?
                                <View transparent style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                    <Image
                                        source={{ uri: home_team.image?.url }}
                                        style={{ height:20, width:20, marginLeft:2 }}
                                        resizeMode="cover"
                                    />
                                    <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='description'>{!bracket?.hide_seeds?round_event.home_seed:''}</Text>
                                    {compact ?
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('home', player_bracket_pick)} theme='h2'>{home_team.abbr}</Text>
                                    :
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('home', player_bracket_pick)} theme='h2'>{home_team.market_name} {!no_name?home_team.name:''}</Text>
                                    }
                                </View>
                                :
                                <View transparent>
                                    {home_placeholder_pick && home_placeholder_team ?
                                    <View style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                        <Image
                                            source={{ uri: home_placeholder_team.image?.url }}
                                            style={{ height:20, width:20, marginLeft:2 }}
                                            resizeMode="cover"
                                        />
                                        <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='action'>{!bracket?.hide_seeds?home_placeholder_pick.pick_seed:''}</Text>
                                        {compact ?
                                        <Text style={{ flex:1 }} size={10} theme='h2'>{home_placeholder_team.abbr}</Text>
                                        :
                                        <Text style={{ flex:1 }} size={10} theme='h2'>{home_placeholder_team.market_name} {!no_name?home_placeholder_team.name:''}</Text>
                                    }
                                    </View>
                                    :
                                    <Text color='transparent'>select</Text>
                                    }
                                </View>
                                }
                            </View>
                        </View>
                        {round_event?.home_side_id && home_placeholder_pick && home_placeholder_team?
                        <View transparent style={{ padding:7, borderBottomRightRadius:4, borderBottomLeftRadius:4, borderTopWidth:1, borderTopColor:Colors.borders.light }}>
                            <Text size={10} theme='h2' color={home_placeholder_pick.result_ind=='win'?Colors.text.success:Colors.text.error}>{home_placeholder_team.market_name} {!no_name?home_placeholder_team.name:''}</Text>
                        </View>
                        :<></>}
                    </View>
                )
        }
    }

    /*
    let winning_side:string | undefined = undefined
    if(round_event.status == 'closed'){
        winning_side = round_event.winning_side_id == round_event.away_side_id ? 'away' : 'home'
    }
    */
    const renderRightSide = (side:'away'|'home') => {
        switch(side){
            case 'away':
                return (
                    <View transparent>
                        {round_event?.away_side_id && away_placeholder_pick && away_placeholder_team ?
                        <View transparent style={{ padding:7, borderTopRightRadius:8, borderTopLeftRadius:8, borderBottomWidth:1, borderBottomColor:Colors.borders.light }}>
                            <Text size={10} theme='h2' color={away_placeholder_pick.result_ind=='win'?Colors.text.success:Colors.text.error}>{away_placeholder_team.market_name} {!no_name?away_placeholder_team.name:''}</Text>
                        </View>
                        :<></>}
                        <View style={{ flexDirection:'row', alignItems:'center', padding:12, borderTopRightRadius:!round_event?.away_side_id || !round_event.away_placeholder?8:0, borderTopLeftRadius:!round_event?.away_side_id || !round_event.away_placeholder?8:0 }}>
                            <View transparent style={{ flex:1, marginRight:5, marginLeft:0 }}>
                                {round_event.away_side_id && away_team ?
                                <View style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                    <Image
                                        source={{ uri: away_team.image?.url }}
                                        style={{ height:20, width:20, marginRight:2 }}
                                        resizeMode="cover"
                                    />
                                    <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='description'>{!bracket?.hide_seeds?round_event.away_seed:''}</Text>
                                    {compact ?
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('away', player_bracket_pick)} theme='h2'>{away_team.abbr}</Text>
                                    :
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('away', player_bracket_pick)} theme='h2'>{away_team.market_name} {!no_name?away_team.name:''}</Text>                                
                                    }
                                </View>
                                :
                                <View transparent>
                                    {away_placeholder_pick && away_placeholder_team ?
                                    <View transparent style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                        <Image
                                            source={{ uri: away_placeholder_team.image?.url }}
                                            style={{ height:20, width:20, marginRight:2 }}
                                            resizeMode="cover"
                                        />
                                        <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='description'>{!bracket?.hide_seeds?away_placeholder_pick.pick_seed:''}</Text>
                                        {compact ?
                                        <Text style={{ flex:1 }} size={10} theme='h1'>{away_placeholder_team.abbr}</Text>
                                        :
                                        <Text style={{ flex:1 }} size={10} theme='h1'>{away_placeholder_team.market_name} {!no_name?away_placeholder_team.name:''}</Text>
                                        }
                                    </View>
                                    :
                                    <Text color='transparent'>select</Text>
                                    }
                                </View>
                                }
                            </View>
                            <View transparent style={{ flexDirection:'row', alignItems:'center', borderLeftWidth:1, borderLeftColor:Colors.borders.light }}>
                                {round_event.event_id && !no_name ?
                                    <Text style={{ margin:5}} size={10} theme='h2'>{getScore(away_team?.team_id)}</Text>
                                :<></>}
                                <View transparent style={{ marginLeft:5 }}>
                                    {renderButton('away')}
                                </View>
                            </View>
                        </View>
                    </View>
                )
            case 'home':
                return (
                    <View transparent>
                        <View style={{ flexDirection:'row', alignItems:'center', padding:12, borderBottomRightRadius:!round_event?.home_side_id || !round_event.home_placeholder?8:0, borderBottomLeftRadius:!round_event?.home_side_id || !round_event.home_placeholder?8:0  }}>

                            <View transparent style={{ flex:1, marginRight:5 }}>
                                {round_event.home_side_id && home_team ?
                                <View transparent style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                    <Image
                                        source={{ uri: home_team.image?.url }}
                                        style={{ height:20, width:20, marginRight:2 }}
                                        resizeMode="cover"
                                    />
                                    <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='description'>{!bracket?.hide_seeds?round_event.home_seed:''}</Text>
                                    {compact ?
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('home', player_bracket_pick)} theme='h2'>{home_team.abbr}</Text>
                                    :
                                    <Text style={{ flex:1 }} size={10} color={getPickColor('home', player_bracket_pick)} theme='h2'>{home_team.market_name} {!no_name?home_team.name:''}</Text>
                                    }
                                </View>
                                :
                                <View transparent>
                                    {home_placeholder_pick && home_placeholder_team ?
                                    <View style={{ flexGrow:1, flexDirection:'row', alignItems:'center' }}>
                                        <Image
                                            source={{ uri: home_placeholder_team.image?.url }}
                                            style={{ height:20, width:20, marginRight:2 }}
                                            resizeMode="cover"
                                        />
                                        <Text style={{ paddingRight: 5, borderRightWidth:1, borderColor:Colors.borders.light }} size={10} theme='action'>{!bracket?.hide_seeds?home_placeholder_pick.pick_seed:''}</Text>
                                        {compact ?
                                        <Text style={{ flex:1 }} size={10} theme='h2'>{home_placeholder_team.abbr}</Text>
                                        :
                                        <Text style={{ flex:1 }} size={10} theme='h2'>{home_placeholder_team.market_name} {!no_name?home_placeholder_team.name:''}</Text>
                                        }
                                    </View>
                                    :
                                    <Text color='transparent'>select</Text>
                                    }
                                </View>
                                }
                            </View>
                            <View transparent style={{ flexDirection:'row', alignItems:'center', borderLeftWidth:1, borderLeftColor:Colors.borders.light }}>
                                {round_event.event_id && !no_name ?
                                    <Text style={{ margin:5}} size={10} theme='h2'>{getScore(home_team?.team_id)}</Text>
                                :<></>}
                                <View transparent style={{ marginLeft:5 }}>
                                    {renderButton('home')}
                                </View>
                            </View>
                        </View>
                        {round_event?.home_side_id && home_placeholder_pick && home_placeholder_team?
                        <View transparent style={{ padding:7, borderBottomRightRadius:4, borderBottomLeftRadius:4, borderTopWidth:1, borderTopColor:Colors.borders.light }}>
                            <Text size={10} theme='h2' color={home_placeholder_pick.result_ind=='win'?Colors.text.success:Colors.text.error}>{home_placeholder_team.market_name} {!no_name?home_placeholder_team.name:''}</Text>
                        </View>
                        :<></>}
                    </View>
                )
        }
    }


    return (
        <View transparent float style={{ flexDirection:'row', borderRadius:8, minWidth:125, width:round_width }}>
            {!compact && orientation != 'left' && onSelectContest ?
            <Button style={{ padding:8, justifyContent:'center', alignItems:'center', borderRightWidth:1, borderColor:Colors.borders.light, borderRadius:0, borderTopLeftRadius:8, borderBottomLeftRadius:8 }}
            onPress={() => onSelectContest(round_event, player_bracket_pick, away_placeholder_pick, home_placeholder_pick)}>
                <Icons.AlertIcon size={16} color={Colors.text.action} />
            </Button>
            :<></>}
            <View transparent style={{ flex:1  }}>
                <Button transparent style={{ padding:0, borderBottomWidth:1, borderColor:Colors.borders.light}} onPress={() => handleSelectAway()}>
                    {orientation == 'left' ? renderLeftSide('away') : renderRightSide('away')}
                </Button>
                <Button transparent style={{ padding:0 }} onPress={() => handleSelectHome()}>
                    {orientation == 'left' ? renderLeftSide('home') : renderRightSide('home')}
                </Button>
                {loading ?
                <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, borderRadius:8, justifyContent:'center', alignItems:'center' }}>
                    <ActivityIndicator
                        size='large'
                        color={Colors.text.h1}
                    />
                </View>
                :<></>}
            </View>
            {!compact && orientation == 'left' && onSelectContest ?
            <Button style={{ padding:8, justifyContent:'center', alignItems:'center', borderLeftWidth:1, borderColor:Colors.borders.light, borderRadius:0, borderTopRightRadius:8, borderBottomRightRadius:8 }}
            onPress={() => onSelectContest(round_event, player_bracket_pick, away_placeholder_pick, home_placeholder_pick)}>
                <Icons.AlertIcon size={16} color={Colors.text.action} />
            </Button>
            :<></>}
        </View>
        
    )
}

export default RoundEventCard